import { normalizeAnswer } from "../game/core.js";

export interface CountyShape {
  id: string;
  name: string;
  markup: string;
}

export function countyAnswerKey(value: string): string {
  return normalizeAnswer(value)
    .replace(/\bfylke\b/g, "")
    .replace(/[-\s]+/g, " ")
    .trim();
}

export function countyAnswerMatches(input: string, countyName: string): boolean {
  return countyAnswerKey(input) === countyAnswerKey(countyName);
}

function shuffled<T>(items: T[], random: () => number): T[] {
  const result = [...items];
  for (let index = result.length - 1; index > 0; index -= 1) {
    const swap = Math.floor(random() * (index + 1));
    [result[index], result[swap]] = [result[swap], result[index]];
  }
  return result;
}

export function selectCountyRound(pool: CountyShape[], count: number, random: () => number = Math.random): CountyShape[] {
  return shuffled(pool, random).slice(0, Math.max(0, Math.min(count, pool.length)));
}

export function buildCountyOptions(
  target: CountyShape,
  pool: CountyShape[],
  count: 3 | 5,
  random: () => number = Math.random,
): string[] {
  const alternatives = shuffled(
    pool.filter((county) => county.id !== target.id && countyAnswerKey(county.name) !== countyAnswerKey(target.name)),
    random,
  ).slice(0, Math.max(0, count - 1));
  return shuffled([target, ...alternatives], random).map((county) => county.name);
}

export function countyAutocomplete(pool: CountyShape[], query: string, max = 6): string[] {
  const needle = countyAnswerKey(query);
  if (!needle) return [];
  return pool
    .map((county) => county.name)
    .filter((name) => countyAnswerKey(name).startsWith(needle))
    .sort((a, b) => a.localeCompare(b, "nb"))
    .slice(0, max);
}
